if (!customElements.get("insurance-read-more")) {
  customElements.define(
    "insurance-read-more",
    class extends HTMLElement {
      constructor() {
        super();
        this.handleReadMore = this.handleReadMore.bind(this);
      }

      connectedCallback() {
        this.readMoreButtons = this.querySelectorAll(".addon-modal__read-more");
        if (this.readMoreButtons) {

            this.prepareReadMoreContent();

            this.readMoreButtons.forEach(btn => {
                btn.addEventListener("click", this.handleReadMore);
            });
        }
      }

      disconnectedCallback() {
        if (this.readMoreButtons) {
          this.readMoreButtons.forEach(btn => {
            btn.removeEventListener("click", this.handleReadMore);
          });
        }
      }

      handleReadMore(e) {
        e.stopPropagation();
        const btn = e.currentTarget;
        const contentBlock = btn.previousElementSibling;
        if (!contentBlock) return;
        const hiddenPart = contentBlock.querySelector(".hidden-part");
        if (!hiddenPart) return;

        const isHidden = hiddenPart.style.display === "none";
        hiddenPart.style.display = isHidden ? "" : "none";
        btn.textContent = isHidden ? "Hide" : "Read More";
      }

      prepareReadMoreContent() {
        this.readMoreButtons.forEach(btn => {
          const content = btn.parentElement.previousElementSibling;
          if (!content) return;

          if (content.querySelector(".visible-part")) return;

          const parts = content.innerHTML.split(/(?:<br\s*\/?>)+/i);
          if (parts.length < 2) {
            btn.parentElement.style.display = "none";
            return;
          }

          content.innerHTML = `
            <span class="visible-part">${parts[0]}</span>
            <span class="hidden-part" style="display:none;">${parts.slice(1).join('<br>')}</span>
          `;
        });
      }
    }
  );
}
